<template>
  <sme-card :title="$t('dashboard.shell.pill.shifts')" :to="{ name: 'shifts' }">
    <p>{{ $t('dashboard.shifts.intro') }}</p>
    <div>
      <sme-info-box id="shifts" :title="$t('dashboard.shifts.infoBoxTitle')">
        <h4>{{ $t('dashboard.shifts.syncingTitle') }}</h4>
        <i18n path="dashboard.shifts.syncingBody" tag="p">
          <template #integrationLink>
            <router-link :to="{ name: 'sme-integrations' }" target="_blank">{{
              $t('common.integrationLinkText')
            }}</router-link>
          </template>
        </i18n>
        <h4>{{ $t('dashboard.shifts.uploadingTitle') }}</h4>
        <i18n path="dashboard.shifts.uploadingBody" tag="p">
          <template #uploadLink>
            <router-link :to="{ name: 'sme-shift-add' }" target="_blank">{{
              $t('dashboard.shifts.uploadLinkText')
            }}</router-link>
          </template>
        </i18n>
        <h4>{{ $t('dashboard.shifts.salariedTitle') }}</h4>
        <p>{{ $t('dashboard.shifts.salariedBody') }}</p>
      </sme-info-box>
      <sme-box>
        <shift-status-alerts />
      </sme-box>
    </div>

    <template #footer>
      <b-button :to="{ name: 'shifts' }" variant="outline-primary">{{
        $t('dashboard.shifts.viewShiftsButton')
      }}</b-button>
      <b-button v-if="canAddShifts && State.state.claims.a" :to="{ name: 'sme-shifts-upload' }" variant="primary">{{
        $t('dashboard.shifts.addShiftsButton')
      }}</b-button>
    </template>
  </sme-card>
</template>

<script setup>
import ShiftStatusAlerts from '@/components/ShiftStatusAlerts.vue';
import SmeBox from '@/components/atoms/SmeBox';
import SmeCard from '@/components/atoms/SmeCard';
import SmeInfoBox from '@/components/atoms/SmeInfoBox';
import useFeatureFlags from '@/composables/useFeatureFlags';
import State from '@/state/State';

const { canAddShifts } = useFeatureFlags();
</script>
